var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_5936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9.5H5.625V10.625H12.375V9.5Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 6.125H5.625V7.25H12.375V6.125Z",
    fill: "#DCE0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17.375L5.52612 15.5227C4.53569 14.9959 3.70744 14.2093 3.13027 13.2473C2.55309 12.2853 2.24878 11.1843 2.25 10.0625V2.75C2.25033 2.45173 2.36896 2.16577 2.57987 1.95487C2.79078 1.74396 3.07674 1.62533 3.375 1.625H14.625C14.9233 1.62533 15.2092 1.74396 15.4201 1.95487C15.631 2.16577 15.7497 2.45173 15.75 2.75V10.0625C15.7512 11.1843 15.4469 12.2853 14.8697 13.2472C14.2925 14.2092 13.4643 14.9958 12.4739 15.5226L9 17.375ZM3.375 2.75V10.0625C3.37403 10.9804 3.62304 11.8812 4.09531 12.6683C4.56758 13.4554 5.24527 14.099 6.05565 14.53L9 16.1L11.9444 14.53C12.7547 14.099 13.4324 13.4554 13.9047 12.6683C14.377 11.8812 14.626 10.9804 14.625 10.0625V2.75H3.375Z",
    fill: "#DCE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_5936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectRisk);
export default __webpack_public_path__ + "static/media/project_risk.f85dbfec5dee14c3a3670129b5374a47.svg";
export { ForwardRef as ReactComponent };